<template>
  <span class="app-price" :class="{ striped, small }">
    <template v-if="!smallCase">
      <template v-if="showSign">
        <template v-if="price > 0">+</template>
        <template v-else-if="price < 0">-</template>
      </template>

      {{ formatted }}
    </template>

    <template v-else>
      <small v-if="showSign">
        <template v-if="price > 0">+</template>
        <template v-else-if="price < 0">-</template>
      </small>

      <small v-html="currency"></small> {{ integer
      }}<small v-html="`,${decimal}`"></small>
    </template>
  </span>
</template>

<script>
import currency from 'currency.js'

const currencySeparator = ' '

export default {
  name: 'AppPrice',

  props: {
    modelValue: {
      type: [String, Number],
      required: false,
    },

    smallCase: {
      type: Boolean,
      default: false,
    },

    striped: {
      type: Boolean,
      default: false,
    },

    small: {
      type: Boolean,
      default: false,
    },

    showSign: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    price() {
      return this.$attrs.price ?? this.$attrs.value ?? this.modelValue
    },

    parsed() {
      return currency(this.price, {
        separator: '.',
        decimal: ',',
        symbol: 'R$ ',
        precision: 2,
        formatWithSymbol: true,
      })
    },

    formatted() {
      const { parsed, showSign } = this

      let formatted = parsed.format()

      if (showSign) formatted = formatted.replace('-', '')

      return formatted
    },

    formattedSplit() {
      return this.formatted.split(',', 2)
    },

    currency() {
      return this.formattedSplit[0].split(currencySeparator, 1)[0]
    },

    integer() {
      return this.formattedSplit[0].split(currencySeparator, 2)[1]
    },

    decimal() {
      return this.formattedSplit[1]
    },
  },
}
</script>

<style lang="scss" scoped>
.app-price {
  line-height: 1;

  small {
    font-size: 65%;
  }

  &.striped {
    position: relative;

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 0;
      border-top: 1px solid currentColor;
      position: absolute;
      left: 0;
      right: 0;
      top: calc(50% - 1px);
    }
  }

  &.small {
    font-size: 75%;
  }
}
</style>
